<template>
		<div class="w1200">
			<div class="association-brief-box">
				<div class="crumbs">
                     <span><a href="#/">首页 ></a></span>
                     <span>协会简介</span>
				</div>
				<div class="article-box w1000">
					<h2>北京建筑设施服务企业协会简介</h2>
					<p>北京建筑设施服务企业协会是经北京市社会团体登记管理机关核准登记的非营利性社会团体。协会秉承“感恩、进步、共享”的办会发展理念，搭建跨界交流，共创商机的发展平台。作为政府与企业间的纽带，协会本着遵守国家法律、法规、政策的原则，联合清洁保洁企业、环境科技企业、设施维护企业、餐饮企业、空气检测企业、节能环保企业、保安企业、停车公司等建筑设施服务企业自愿联合发起。

					</p>
					<p>协会为企业提供各类培训、商务交流、企业发展咨询等服务，设有私董会、专属宣传渠道平台等，帮助就业者提升专业水平，促进企业产供销平台发展，并承办各级政府的委托事项，将与国际同类组织建立联系，搭建国际专业性的交流平台，建筑设施服务企业交流大会、服务商供应商产品大会，带动整个行业发展，推动横向经济联合，实现跨界发展。</p>
				    <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
				</div>
			</div>

		</div>
</template>

<script>
	import Vue from 'vue';
	export default {

		data() {
			return {}
		},
		methods: {

		},
		components: {}
	}
</script>

<style>

	@import "../assets/css/detail.css";
</style>


// WEBPACK FOOTER //
// src/components/Introduction.vue